var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height pa-0 ma-0",attrs:{"fluid":""}},[_c('kubiqa-website-themes-' + _vm.theme + '-' + _vm.page,{tag:"component",staticClass:"pa-0 ma-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }